import React, {useEffect, useState} from 'react';

import useDataSource from "../../../hooks/useDataSource";

import {
    getFieldFormatters
} from "../../../utilities/DataSourceUtilities";

import {
    formatDate,
    formatDuration,
    formatNumber,
    formatStyle,
    formatText,
    formatSuffix
} from "../../../utilities/FormatUtilities";

import { LinearProgress, styled, Typography } from "@mui/material";


const PREFIX = 'TitleCard';

const classes = {
    linearProgress: `${PREFIX}-linearProgress`,
    paper: `${PREFIX}-paper`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.linearProgress}`]: {
        height: '1px'
    },

    [`& .${classes.paper}`]: {
        display: 'flex',
        flexDirection: 'column',
        //justifyContent: 'center',
        boxShadow: 'none',
        height: '100%',
        overflow: 'auto',
        padding: '8px'
    }
}));

export default function TitleCard({configuration}) {


    const headingVariant = configuration.element?.headingVariant ? configuration.element.headingVariant : '';
    const headingColor = configuration.element?.headingColor ? configuration.element.headingColor : '';
    const subtitleVariant = configuration.element?.subtitleVariant ? configuration.element.subtitleVariant : '';
    const subtitleColor = configuration.element?.subtitleColor ? configuration.element.subtitleColor : '';
    const dataSourceName = configuration.dataSource?.name ? configuration.dataSource?.name : '';
    const fields = configuration.dataSource?.fields ? configuration.dataSource?.fields : [];

    // App State
    const userDataSource = useDataSource(dataSourceName);

    // Component State
    const [titles, setTitles] = useState({heading: "", subtitle: ""});
    const [showProgress, setShowProgress] = useState(configuration.element?.showFetching !== undefined ? configuration.element?.showFetching : true);

    // Data
    useEffect(() => {
        // console.log("TitleCard: useEffect({}, [userDataSource.data])")
        // console.log('Fetching: {0}'.format(userDataSource.fetching));
        // console.log('Fetched: {0}'.format(userDataSource.fetched));
        // console.log('isData: {0}'.format(userDataSource.data ? true : false));

        if (userDataSource.data && userDataSource.fetched && userDataSource.data.length > 0) {
            let formattedValue;
            let componentTitle;
            let componentSubtitle;

            for (const field of fields) {
                if (field.attribute === 'heading') {
                    formattedValue = userDataSource.data[0][field.name] ? userDataSource.data[0][field.name] : "";
                } else if (field.attribute === 'subtitle') {
                    formattedValue = userDataSource.data[0][field.name] ? userDataSource.data[0][field.name] : "";
                }

                // Format Value
                const formatters = getFieldFormatters(userDataSource, field.name); // Used when formatters are on the data source
                // const formatters = field.formatters; // used when formatters are on the component

                for (const formatter of formatters) {
                    if (formatter.type.toUpperCase() === 'DATE') {
                        formattedValue = formatDate(formattedValue, formatter.config);
                        // formattedValue = DateUtilities.dateMonthYearString(formattedValue);
                    } else if ((formatter.type.toUpperCase() === 'DURATION') && (userDataSource.name.toUpperCase() === 'DURATION')) {
                        formattedValue = formatDuration(userDataSource.data[0].min, userDataSource.data[0].max, formatter.config);
                    } else if (formatter.type.toUpperCase() === 'NUMBER') {
                        formattedValue = formatNumber(formattedValue, formatter.config);
                    } else if (formatter.type.toUpperCase() === 'STYLE') {
                        formattedValue = formatStyle(formattedValue, formatter.config);
                    } else if (formatter.type.toUpperCase() === 'TEXT') {
                        formattedValue = formatText(formattedValue, formatter.config);
                    } else if (formatter.type.toUpperCase() === 'SUFFIX') {
                        formattedValue = formatSuffix(formattedValue, formatter.config);
                    } else {

                    }
                }

                if (field.attribute === 'heading') {
                    componentTitle = formattedValue;
                } else if (field.attribute === 'subtitle') {
                    componentSubtitle = formattedValue;
                }
            }
            setTitles({heading: componentTitle, subtitle: componentSubtitle});
        }
        else {
            setTitles({heading: '---- ----', subtitle: '--'});
        }
    }, [userDataSource.data]);

    return (
        <Root style={{width: '100%', height: '100%'}}>
            {showProgress && userDataSource.fetching &&
            <LinearProgress className={classes.linearProgress}/>
            }
            {showProgress && !userDataSource.fetching &&
            <div className={classes.linearProgress}/>
            }
            <div className={classes.paper} style={{display: 'flex'}}>
                <Typography variant={headingVariant} color={headingColor} display="block">
                    {titles.heading}
                </Typography>
                <Typography variant={subtitleVariant} color={subtitleColor} display="block">
                    {titles.subtitle}
                </Typography>
            </div>
        </Root>
    );
}
